<template>
  <LogoWrapper>
    <Logo>
      <svg width="644px" height="218px" viewBox="0 0 644 218" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Branding" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="og-card" transform="translate(-278.000000, -206.000000)">
            <g id="wilder-white" transform="translate(279.000000, 207.000000)">
              <g>
                <polygon id="Fill-4" :fill="bgcolor" points="0.710176991 215.289474 641.289823 215.289474 641.289823 0.710526316 0.710176991 0.710526316" class="bw-animation"></polygon>
                <g id="mark">
                  <polygon id="Stroke-5" :stroke="strokecolor" stroke-width="3" points="0.710176991 215.289474 641.289823 215.289474 641.289823 0.710526316 0.710176991 0.710526316"></polygon>
                  <path d="M88.5099265,154.2564 L63.1480858,61.7430316 L85.7359752,61.7430316 L98.1527097,113.287453 C99.2094531,117.912979 100.002011,121.481242 100.398289,123.727926 L102.511776,113.153874 L115.458303,61.7430316 L137.649913,61.7430316 L150.595019,113.153874 L152.708506,123.727926 L154.954086,113.287453 L167.37082,61.7430316 L189.96013,61.7430316 L164.596869,154.2564 L142.00898,154.2564 L126.552688,93.8588211 L111.097816,154.2564 L88.5099265,154.2564 Z" id="Fill-7" :fill="color" class="bw-animation-reverse"></path>
                  <polygon id="Fill-8" :fill="color" class="bw-animation-reverse" points="202.372035 154.256684 223.771088 154.256684 223.771088 61.7433158 202.372035 61.7433158"></polygon>
                  <polygon id="Fill-9" :fill="color" class="bw-animation-reverse" points="284.285838 134.433853 284.285838 61.7441684 305.684891 61.7441684 305.684891 154.256116 237.919803 154.256116 237.919803 134.433853"></polygon>
                  <path d="M351.917697,134.961205 C369.353963,134.961205 380.05491,125.047942 380.05491,108.131732 C380.05491,91.0833632 369.353963,81.0393632 351.917697,81.0393632 L341.482357,81.0393632 L341.482357,134.961205 L351.917697,134.961205 Z M320.083304,154.256258 L320.083304,61.7443105 L349.934883,61.7443105 C365.391175,61.7443105 377.80933,65.7090474 387.187927,73.6385211 C396.698618,81.4358368 401.453963,92.9335737 401.453963,108.131732 C401.453963,123.199153 396.698618,134.696889 387.187927,142.494205 C377.80933,150.292942 365.391175,154.256258 349.934883,154.256258 L320.083304,154.256258 Z" class="bw-animation-reverse" id="Fill-10" :fill="color"></path>
                  <polygon id="Fill-11" :fill="color" class="bw-animation-reverse" points="417.961317 154.2564 417.961317 61.7430316 485.462219 61.7430316 485.462219 80.5094526 439.36037 80.5094526 439.36037 97.2949263 481.765038 97.2949263 481.765038 115.534137 439.36037 115.534137 439.36037 135.489979 485.859919 135.489979 485.859919 154.2564"></polygon>
                  <path d="M523.76803,79.1890105 L523.76803,100.334274 L544.770804,100.334274 C552.69638,100.334274 556.527074,96.2373789 556.527074,89.7616421 C556.527074,83.2859053 552.69638,79.1890105 544.770804,79.1890105 L523.76803,79.1890105 Z M555.86803,154.256116 L535.261535,117.780537 L523.76803,117.780537 L523.76803,154.256116 L502.368977,154.256116 L502.368977,61.7441684 L542.657318,61.7441684 C564.718256,61.7441684 577.267083,71.5238526 577.267083,88.9686947 C577.267083,102.316642 570.264738,110.511853 557.187539,115.928905 L578.852198,154.256116 L555.86803,154.256116 Z" id="Fill-12" :fill="color" class="bw-animation-reverse"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Logo>
  </LogoWrapper>
</template>

<script>
import styled from 'vue-styled-components'
import * as _ from '@/styles/mixins'

// STYLES
const LogoWrapper = styled.div`
  ${_.flexCenteredAll};
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-bottom: 6rem;
`

const Logo = styled.div`
  width: 100%;
  max-width: 70rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  z-index: 100;
  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  transform: translateY(-4rem);
  ${_.media.desktop`
    transform: translateY(0);
    width: 50vw;
    max-width: 70rem;
    padding: 0;
  `}
`

export default {
  components: {
    Logo,
    LogoWrapper
  },
  props: ['color', 'bgcolor', 'strokecolor']
}
</script>
